/* Шапка экрана инструмента (APP-SPEC-5 §1.1, BotCore.html.title): название и под ним цена за единицу подзаголовком
   («1 C в минуту», «3 C за 100 знаков»). Ставится в общий слот шапки студии (StudioHeaderContent), второй шапки в теле нет.
   Единица цены берётся только из формы сервера: нет числа — нет подзаголовка. */
import type { ReactNode } from 'react';
import { uiText } from '../../../i18n';
import { StudioHeaderContent } from '../StudioHeaderContent';

export function ToolHeader({ title, unit, enabled = true, aside }: { title: string; unit?: string; enabled?: boolean; aside?: ReactNode }) {
  return (
    <StudioHeaderContent enabled={enabled}>
      <div className="studio-photo-header tool-header">
        <div className="photo-header-title bc-tt">
          <h2 className="pf-title">{uiText(title)}</h2>
          {unit && <small className="bc-unit">{unit}</small>}
        </div>
        {aside}
      </div>
    </StudioHeaderContent>
  );
}
